// Note: You probably do not want to change any values in here because this
//       file might need to be updated with new default values for new
//       configuration options. Use the [config.local.js] file instead!
window.mumbleWebConfig = {
  // Which fields to show on the Connect to Server dialog
  'connectDialog': {
    'address': true,
    'port': true,
    'username': true,
    'password': true,
    'channelName': false
  },
  // Default values (can be changed by passing a query parameter of the same name)
  'defaults': {
    // Connect Dialog
    'address': window.location.hostname,
    'port': '443',
    'username': '1710855',
    'password': '123456',
    'joinDialog': false,
    // replace whole dialog with single "Join Conference" button
    'avatarurl': '' // download and set the user's Mumble avatar to the image at this URL

  }
};